import React from "react";
import PropTypes from "prop-types";
import Link from "gatsby-link";
import SaveContainer from "../Save/container";
import styles from "./index.module.css";

const Preview = ({
  articleId,
  title,
  titleNumber,
  path,
  onClick,
  isSelected
}) => {
  return (
    <Link
      className={isSelected ? styles.rootActive : styles.root}
      to={path}
      activeClassName={styles.rootActive}
      onClick={onClick ? e => onClick(e, articleId) : null} // Optional custom click handler
    >
      <div className={styles.header}>
        <h1 className={styles.number}>{titleNumber}</h1>
        <div className={styles.save}>
          <SaveContainer articleId={articleId} />
        </div>
      </div>
      <h3 className={styles.title}>{title}</h3>
      <div className={styles.view}>
        <span className={styles.viewText}>View</span>
      </div>
    </Link>
  );
};

Preview.propTypes = {
  articleId: PropTypes.number,
  title: PropTypes.string,
  titleNumber: PropTypes.string,
  path: PropTypes.string,
  type: PropTypes.string,
  onClick: PropTypes.func,
  isSelected: PropTypes.bool
};

export default Preview;



// WEBPACK FOOTER //
// ./src/components/Preview/index.js